import EventActionProto from '../event-action-proto';
import {ITEM_VIEW_CHAT} from "core/gd/app-manager/item-view";

module.exports = class EventTaskUpdateCustomFieldValue extends EventActionProto {

    constructor(uid, data, fromSID, companyId) {
        super(uid, data);
        this.fromSID = fromSID
    }

    process() {
        // do not process event for user who initialed update
        if (this.fromSID === gd.sessionId) return false;

        // make sure we are updating only if we are viewing this task
        const chatView = gd.itemView.findByContainerId(ITEM_VIEW_CHAT);
        if (chatView && chatView.app.chatId === this.data.chatId) {
            chatView.app.sessionTaskUpdateCustomFieldValue(this.data.customFieldId, this.data.value);
        }

        super.process();
    }

};